import { countries } from 'utils/countries'
import { languages } from 'utils/languages'
import { timezones } from 'utils/time'

import * as Luxon from 'luxon'

import { signal } from 'modules/Signals';

export let country;
// console.log('Current Country', country);
export const setCountry = (newCountry) => {
  if (newCountry in countries) {
    const changed = country !== newCountry;
    country = newCountry;
    // console.log('Current Country', country);
    if (changed) {
      signal('change:environment');
      signal('change:environment:country', country);
    }
  }
}

export let language = window.navigator.language;
// console.log('Current Language', language);
export const setLanguage = (newLanguage) => {
  if (newLanguage in languages) {
    const changed = language !== newLanguage;
    language = newLanguage;
    // console.log('Current Language', language);
    if (changed) {
      signal('change:environment');
      signal('change:environment:language', language);
    }
  }
}

// export let timezone = moment.tz.guess();
// console.log('Current Timezone', timezone);
// export const setTimezone = (newTimezone) => {
//   if (newTimezone in timezones) {
//     const changed = timezone !== newTimezone;
//     timezone = newTimezone;
//     moment.tz.setDefault(timezone);
//     console.log('Current Timezone', timezone);
//     if (changed) {
//       signal('change:environment');
//       signal('change:environment:timezone', timezone);
//     }
//   }
// }

export let REMOTE_TRJSON = undefined;
export const setTranslation = async (url, headers, timeout) => {
  const controller = new AbortController();
  const timeoutId = timeout ? setTimeout(() => controller.abort(), timeout) : 0;
  await fetch(url, {
    method: 'get',
    signal: controller.signal,
    headers,
  })
    .then(res => {
      clearTimeout(timeoutId);
      return res.json();
    })
    .then((res) => {
      REMOTE_TRJSON = res;
      signal('change:environment');
      signal('change:environment:translation', url);
    })
    .catch((err) => {
      console.error(err);
    });
}

window.setLanguage = setLanguage;
window.setTranslation = setTranslation;
